import { Images } from "@abcya/abcya_phaser";
import { strPadLeft } from "../phaserHelpers";

export default class PatternDisplay extends Phaser.GameObjects.Container
{
	constructor(scene, game, x, y, atlasId, selectorTopSize)
	{
        super(scene, x, y)

        this.sceneX = x;
        this.sceneY = y;
        this.atlasId = atlasId;
        this.selectorTopSize = selectorTopSize;
        this.sampleTiles = [[],[]];
        let sX = 2;
        let sY = this.selectorTopSize;

        this.sampleGroup = this.scene.add.container();
        this.add(this.sampleGroup);

        this.sampleTiles[0][0] = Images.addImage(0, 0, "Tile_002", this.sampleGroup);
        this.tileSize = this.sampleTiles[0][0].width;
        this.sampleTiles[0][1] = Images.addImage(this.tileSize, 0, "Tile_004", this.sampleGroup);
        this.sampleTiles[1][0] = Images.addImage(0, this.tileSize, "Tile_006", this.sampleGroup);
        this.sampleTiles[1][1] = Images.addImage(this.tileSize, this.tileSize, "Tile_008", this.sampleGroup);

        const samples = [this.sampleTiles[0][0], this.sampleTiles[0][1], this.sampleTiles[1][0], this.sampleTiles[1][1]];
        //this.sampleTiles[0][0]

        this.sampleGroup.x = sX;
        this.sampleGroup.y = sY;

        this.bg = Images.addImage(0, 0, "OrnamentSelector", this).setOrigin(0);

        this.graphics = this.scene.add.graphics(this.sceneX, this.sceneY);
        this.graphics.beginPath();
        this.graphics.fillStyle(0xffffff, 0);
        this.graphics.fillCircle(this.x + this.bg.width/2, this.y + this.bg.height/2 + 11, (145/2));
        this.graphics.closePath();

        const mask = new Phaser.Display.Masks.GeometryMask(this.scene,  this.graphics);

        this.sampleGroup.mask = mask;

        for(let each in samples)
        {
            samples[each].setMask(mask);
            samples[each].setOrigin(0);
        }
    
        this.add(this.sampleGroup);

        this.x = this.sceneX;
        this.y = this.sceneY;
    }

    setPattern(pattern) {
        const t1 = "Tile_" + strPadLeft(pattern[0][0], "0", 3);
        const t2 = "Tile_" + strPadLeft(pattern[0][1], "0", 3);
        const t3 = "Tile_" + strPadLeft(pattern[1][0], "0", 3);
        const t4 = "Tile_" + strPadLeft(pattern[1][1], "0", 3);
        this.sampleTiles[0][0].frameName = t1;
        this.sampleTiles[0][1].frameName = t2;
        this.sampleTiles[1][0].frameName = t3;
        this.sampleTiles[1][1].frameName = t4;
        this.sampleTiles[0][0].setFrame(t1);
        this.sampleTiles[0][1].setFrame(t2);
        this.sampleTiles[1][0].setFrame(t3);
        this.sampleTiles[1][1].setFrame(t4);
    };

    updateMaskPos() {
        //this.sampleGroup.mask.x = this.x - this.sceneX;
        // this.sampleGroup.mask.y = this.y - this.sceneY;
        this.graphics.x = this.x - this.sceneX;
        this.graphics.y = this.y - this.sceneY;
        this.graphics.scaleX = this.scaleX;
        this.graphics.scaleY = this.scaleY;
        // this.sampleGroup.mask.scaleX = this.scaleX;
        // this.sampleGroup.mask.scaleY = this.scaleY;
    };

    resetDisplay() {
        this.x = this.sceneX;
        this.y = this.sceneY;
        this.scaleX = 1.0;
        this.scaleY = 1.0;
        this.sampleGroup.mask.x = this.x - this.sceneX;
        this.sampleGroup.mask.y = this.y - this.sceneY;
        // this.sampleGroup.mask.scale.x = this.scale.x;
        // this.sampleGroup.mask.scale.y = this.scale.y;
    };
}